const normalize = value =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase()
    .trim();

const checkName = check => check?.name || check?.nome || check;

const blockDefinitions = [
  {
    key: 'signature_date',
    title: 'Data de assinatura',
    checkLabel: 'Data de assinatura ausente/incorreta',
  },
  {
    key: 'signed_receipt',
    title: 'Recibo de sinal assinado',
    checkLabel: 'Falta de assinatura dos envolvidos',
  },
];

export const salesReceiptReviewContext = transaction => {
  const item = (transaction?.review?.items || []).find(
    reviewItem => reviewItem.section === 'recibo'
  );
  const checks = item?.checks || [];
  const normalizedChecks = checks.map(check => normalize(checkName(check)));
  const blocks = blockDefinitions
    .map(block => ({
      ...block,
      check: checks.find(
        check => normalize(checkName(check)) === normalize(block.checkLabel)
      ),
    }))
    .filter(block => normalizedChecks.includes(normalize(block.checkLabel)));
  const hasCorrections = blocks.length > 0;
  const sectionChecks = blocks.reduce(
    (groups, block) => ({
      ...groups,
      [block.key]: block.check ? [block.check] : [],
    }),
    {}
  );

  return {
    blocks,
    checks,
    hasCorrections,
    isComplete:
      item?.status === 'corrigido' ||
      (hasCorrections && blocks.every(block => block.check?.saved === true)),
    item,
    observation: item?.observation || '',
    sectionChecks,
  };
};
